/* =================== HEADER FULL =================== */
jQuery(document).ready(function ($) {

  /*DESCE E SOBE BARRA DE BUSCA*/
  $('.segura-menu-mobile-pesquisa').on("click", function () {
    $('.segura-menu-mobile-barra-pesquisa').slideToggle();
  });
  /*DESCE E SOBE BARRA DE BUSCA*/

  // Exibe / Oculta busca
  $('.open-busca').on('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    $('.header-busca').toggleClass('active');
    if ($('.header-busca').hasClass('active')) {
      //$('.header-busca #busca').focus();
    }
  });

  // Impede que a busca seja ocultada ao clicar sobre a mesma
  $('.header-busca').on('click', function (ev) {
    ev.stopPropagation();
  });

  // Oculta a busca quando clicar em qualquer parte da tela
  $('body').on('click', function (ev) {
    $('.header-busca').removeClass('active');
  });

  const header = $('.header-full');
  if (header.length > 0) {
    function toggleHeaderFull() {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 100) {
        header.addClass('active');
      } else {
        header.removeClass('active');
      }
    }
    toggleHeaderFull();
    $(window).on('scroll', debounce(function () {
      toggleHeaderFull();
    }, 10));
  }
});
